export default (...arrays) => {
  return [].concat(...arrays)
}